import React, { useState, useEffect } from 'react';

import FAQ_Container from './common/FAQ_Container';
  
  const FAQ = () =>  {

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
            
    useEffect(() => {
            
        // Add event listener for window resize
        window.addEventListener('resize', () => handleWindowSizeChange());

        // Cleanup the event listener when the component unmounts
        return () => window.removeEventListener('resize', () => handleWindowSizeChange());
    }, []);

    // Update window width state on window resize
    const handleWindowSizeChange = () => {
        setWindowWidth(window.innerWidth);
    };

    // Check if the device is mobile or tablet
    const isMobile = windowWidth <= 769;
    const isTablet = windowWidth <= 1024;

	return (
	  <div style={{padding: '3rem 0', boxSizing: 'border-box', maxWidth: '64rem', marginLeft: 'auto', marginRight: 'auto'}}>
        {/* Section Header */}
        <div style={{textAlign: 'center', marginBottom: '2rem'}}>
            {/* Title - Header */}
            <h2 style={{fontSize: `${isMobile ? '2.25rem' : '3rem'}`, fontWeight: 'bold', marginBottom: '1rem'}}>
                Common Questions
            </h2>
            {/* Description - Header */}
            <p style={{fontSize: '1.125rem', lineHeight: '1.75rem', color: 'rgb(153,153,153)', fontWeight: 500}}>
                Everything you need to know about Interview Cheater.
            </p>
        </div>
        {/* FAQ Container */}
        <FAQ_Container />

        <div style={{margin: '2rem .5rem 0', textAlign: 'center'}}>
            <p style={{color: 'rgb(115,115,115)', margin: '0'}}>
                Have more questions? Visit our 
                {' '}
                <a href="/help" className='underline_hover' style={{color: '#FFFF00', textDecoration: 'none'}}>
                    help center
                </a>
                {' '}
                for detailed guides and support.
            </p>
        </div>
	  </div>
	);
  }
  
  export default FAQ;
  